import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import destinations from '../data/destinationsData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronLeft, faChevronRight, faLink } from '@fortawesome/free-solid-svg-icons';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import './DestinationDetail.css';
import { Link } from 'react-router-dom';

const monthsList = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  const categoriesList = [
  "City Tour",
  "Beaches",
  "Wildlife",
  "Mountains",
  "Landscape",
  // "Cruises",
  // "Hiking",
  // "Road Trips",
  // "Walking",
  // "Deserts",
  // "Snowfall",
  // "Temples",
  "Adventure",
  "Winter Activities",
  "Kid Friendly",
  "Weekend Getaways",
  "Historical"
];
  
  // const tags = ["Tour", "Adventure", "Rent", "Innovate", "Hotel", "Modern", "Luxury", "Travel"];
  

function DestinationDetail() {
  const { id } = useParams();
  const destination = destinations.find(d => d.id === parseInt(id));
  const galleryImages = destination?.gallery || [];
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex(prev => (prev + 1) % galleryImages.length);
  };
  
  const handlePrev = () => {
    setActiveIndex(prev => (prev - 1 + galleryImages.length) % galleryImages.length);
  };
  

  if (!destination) return <div>Destination not found</div>;

  return (
    <>
      <Navbar />
      <div className='gap'></div>
      <div className="detail-destination-detail-page">
        <section className="detail-header-banner">
          <h2>Popular Destinations</h2>
          <p className="detail-breadcrumb">Home → {destination.name}</p>
        </section>

        {window.innerWidth <= 768 && (
  <div className="detail-mobile-filters">
    <div className="detail-search-box with-dropdown">
      <select
        className="destination-select"
        onChange={(e) => {
          const selectedId = e.target.value;
          if (selectedId) window.location.href = `/destination/${selectedId}`;
        }}
        defaultValue=""
      >
        <option value="" disabled>Search destination...</option>
        {destinations.map((dest) => (
          <option key={dest.id} value={dest.id}>
            {dest.name}
          </option>
        ))}
      </select>
      <button><FontAwesomeIcon icon={faSearch} /></button>
    </div>

    <select
      className="detail-mobile-dropdown"
      onChange={(e) => {
        const selectedMonth = e.target.value;
        if (selectedMonth) window.location.href = `/PopularDestinations?month=${selectedMonth}`;
      }}
    >
      <option value="">Select Month</option>
      {monthsList.map(month => (
        <option key={month} value={encodeURIComponent(month)}>{month}</option>
      ))}
    </select>

    <select
      className="detail-mobile-dropdown"
      onChange={(e) => {
        const selectedCat = e.target.value;
        if (selectedCat) window.location.href = `/PopularDestinations?category=${selectedCat}`;
      }}
    >
      <option value="">Select Category</option>
      {categoriesList.map(cat => (
        <option key={cat} value={encodeURIComponent(cat)}>{cat}</option>
      ))}
    </select>
  </div>
)}


        <div className="detail-destination-container">
          <div className="detail-left-panel">
            <div className="detail-slider-container">
              <div
                className="detail-slider-main-image"
                style={{ backgroundImage: `url(${galleryImages[activeIndex]})` }}
              />
              <div className="detail-slider-thumbnails">
                <button className="detail-nav-arrow detail-left" onClick={handlePrev}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                {[0, 1, 2].map((offset) => {
                    const index = (activeIndex + offset) % galleryImages.length;
                    return (
                        <div
                        key={index}
                        className="detail-thumbnail"
                        style={{ backgroundImage: `url(${galleryImages[index]})` }}
                        onClick={() => setActiveIndex(index)}
                        />
                    );
                })}

                <button className="detail-nav-arrow detail-right" onClick={handleNext}>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
              <div className="detail-slider-tags">
                <span className="detail-featured-tag">Featured</span>
                <span className="detail-rating-tag">⭐ {destination.rating}</span>
              </div>
            </div>

            <div className="detail-description">
            <h3>{destination.title}</h3>
              <p>{destination.description}</p>
            </div>

            <h4 className="detail-section-heading">Highlights</h4>
            <ul className="detail-destinationul">
              {destination.highlights?.map((point, i) => <li key={i}>{point}</li>)}
            </ul>

            <h4 className="detail-section-heading">Basic Information</h4>
            <table className="detail-table">
              <tbody>
                {Object.entries(destination.basicInfo || {}).map(([key, value], i) => (
                  <tr key={i}><td>{key}</td><td>{value}</td></tr>
                ))}
              </tbody>
            </table>

            <h4 className="detail-section-heading">What's Included</h4>
            <ul className="detail-included-list">
              {destination.included?.map((item, i) => <li key={i}>{item}</li>)}
            </ul>

            <h4 className="detail-section-heading">Travel Tips</h4>
            <ul className="detail-tips-list">
              {destination.tips?.map((tip, i) => <li key={i}>{tip}</li>)}
            </ul>
          </div>

          <div className="detail-right-panel">
          <div className="detail-search-box with-dropdown">
            <select
                className="destination-select"
                onChange={(e) => {
                const selectedId = e.target.value;
                if (selectedId) window.location.href = `/destination/${selectedId}`;
                }}
                defaultValue=""
            >
                <option value="" disabled>Search destination...</option>
                {destinations.map((dest) => (
                <option key={dest.id} value={dest.id}>
                    {dest.name}
                </option>
                ))}
            </select>
            <button><FontAwesomeIcon icon={faSearch} /></button>
            </div>


            <div className="filter-block">
                <h4>Months</h4>
                <div className="heading-underline"></div>
                <ul>
                    {monthsList.map(month => (
                    <li key={month}>
                    <Link to={`/PopularDestinations?month=${encodeURIComponent(month)}`} className="item-left">
                      <FontAwesomeIcon icon={faLink} /> {month}
                    </Link>
                  </li>                  
                    ))}
                </ul>
            </div>

            {/* <div className="filter-block">
                <h4>Categories</h4>
                <div className="heading-underline"></div>
                <ul>
                    {categoriesList.map(cat => (
                    <li key={cat}>
                    <Link to={`/PopularDestinations?category=${encodeURIComponent(cat)}`} className="item-left">
                      <FontAwesomeIcon icon={faLink} /> {cat}
                    </Link>
                  </li>
                  
                    ))}
                </ul>
            </div> */}

            <div className="filter-card">
              <h4>Categories</h4>
              <div className="tags">
                {categoriesList.map(cat => (
                  <Link key={cat} to={`/PopularDestinations?category=${encodeURIComponent(cat)}`}>
                    <span className="tag">{cat}</span>
                  </Link>
                ))}
              </div>
            </div>


            <div className="support-card">
                <h4>Need Help? We Are Here To Help You</h4>
                <div className="logo-rectangle">
                <img src="/logo.png" alt="Sonal Holidays" className="logo-img1" />
                </div>
                <p className="support-text">You Get Online support</p>
                <p className="support-number">+91 97737 49023</p>
                <Link to="/contact" className="support-btn">Contact Us →</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default DestinationDetail;
